import { useSelector } from 'react-redux';

const useGetHealthQuestionnaire = () => {
    return useSelector((state) => state.healthQuestionnaire.healthQuestionnaire);
};

export default useGetHealthQuestionnaire;